import React from "react";
import BackgroundDiv from "../misc/elements/BackgroundDiv";

const makeActiveNumber = (icon, name, value, onClick) => {
  return { icon, name, value };
};

const ActiveNumberHolder = ({ icon, name, value, onClick }) => {
  return (
    <div
      onClick={() => {
        if (onClick) onClick(name);
      }}
      className="divRow"
      style={{
        cursor: "pointer",
        borderRadius: ".5rem/.5rem",
        backgroundColor: "#3f3f3f",
        border: "2px solid white",
      }}
    >
      <img className="icon20" src={icon} />
      <div
        className="divRow"
        style={{
          position: "relative",
          height: "20px",

          paddingRight: "5px",
        }}
      >
        <BackgroundDiv backgroundColor={"#9f9f9f"} noBorder={true} />
        <div
          className="textWhite"
          style={{
            fontSize: "12px",
            zIndex: 1,
            color: "#2f2f2f",
            fontStyle: "italic",
          }}
        >
          {name}
        </div>
      </div>
      <div
        className="divRow"
        style={{
          position: "relative",
          padding: "2px",
          justifyContent: "center",
        }}
      >
        <BackgroundDiv backgroundColor={"#1f1f1f"} />
        <div className="textBoldWhite" style={{ zIndex: 1, marginLeft: "2px" }}>
          {value}
        </div>
      </div>
    </div>
  );
};

export default ActiveNumberHolder;
export { makeActiveNumber };
